export class Value
{


    static list: Record<ValueId, Value> = {};

    static getNumber(id: ValueId, value?: number, options?: Value.Options)
    {
        if (!this.list[id])
        {
            this.list[id] = new Value(value, options);
        }
        else
        {
            let update = false;
            if (value != null)
            {
                update = this.list[id].setValue(value, false) || update;
            }

            if (options != null)
            {
                update = this.list[id].setOptions(options, false) || update;
            }

            if (value != null || options != null)
            {
                this.list[id].onChange();
            }

        }

        return this.list[id];
    }


    static setEnabled(enabled: boolean)
    {
        for (const key in this.list)
        {
            if (this.list[key]._disable_on_spin)
            {
                this.list[key].setOptions({
                    enabled: enabled
                });
            }
        }
    }


    listeners: Array<{
        callback: ValueOnChange;
        scope: any;
    }>;

    protected _value: string;

    protected _decimals: number;
    protected _min?: number | null;
    protected _max?: number | null;
    protected _editable: boolean;
    protected _disable_on_spin: boolean;
    protected _enabled: boolean;

    ignoreDecimals: boolean;

    constructor(value?: number, options?: Value.Options)
    {
        this.listeners = [];
        
        this.ignoreDecimals = false;
        
        this._value = "0.00";

        this._decimals = 2;
        this._editable = true;
        this._disable_on_spin = false;
        this._enabled = true;

        this.setOptions(options || {}, false);
        this.setValue(value || 0, false);
    }


    setOptions(options: Value.Options, update: boolean = true)
    {
        let _update = false;

        if (options.decimals != null && options.decimals != this._decimals)
        {
            this._decimals = options.decimals;
            _update = true;
        }

        if (options.disable_on_spin != null && options.disable_on_spin != this._disable_on_spin)
        {
            this._disable_on_spin = options.disable_on_spin;
            _update = true;
        }

        if (options.editable != null && options.editable != this._editable)
        {
            this._editable = options.editable;
            _update = true;
        }

        if (options.enabled != null && options.enabled != this._enabled)
        {
            this._enabled = options.enabled;
            _update = true;
        }

        if (options.min != null && options.min != this._min)
        {
            this._min = options.min;
            _update = true;
        }

        if (options.max != null && options.max != this._max)
        {
            this._max = options.max;
            _update = true;
        }

        this.setValue(this.value, false);

        if (_update)
        {
            if (update)
            {
                this.onChange();
            }

            return true;
        }

        return false;

    }


    get strValue(): string
    {
        return this._value;
    }


    get value(): number
    {
        return Number(this._value);
    }
    set value(value: number | string)
    {
        this.setValue(value);
    }


    get decimals()
    {
        return this._decimals;
    }


    get min()
    {
        return this._min;
    }


    get max()
    {
        return this._max;
    }


    get enabled()
    {
        return this._enabled && this._editable;
    }
    set enabled(value)
    {
        if (this._enabled != value)
        {
            this._enabled = value;
            this.onChange();
        }
    }


    setValue(value: number | string, update: boolean = true, ignoreDecimals = false): boolean
    {
        value = Number(value);

        if (this.min != null && value < this.min)
        {
            value = this.min;
        }

        if (this.max != null && value > this.max)
        {
            value = this.max;
        }

        value = Number(value).toFixed(this._decimals);
        if (value !== this._value)
        {
            this.ignoreDecimals = ignoreDecimals;
            this._value = value;
            if (update)
            {
                this.onChange();
            }
            return true;
        }

        if (this.ignoreDecimals !== ignoreDecimals)
        {
            this.ignoreDecimals = ignoreDecimals;
            
            this.onChange();
        }

        return false;
    }


    register(callback: ValueOnChange, scope: any)
    {
        this.listeners.push({
            callback: callback,
            scope: scope
        });
    }


    unregister(callback: ValueOnChange, scope: any)
    {
        const idx = this.listeners.findIndex(listener => listener.callback === callback && listener.scope === scope);
        if (idx !== -1)
        {
            this.listeners.splice(idx, 1);
        }
    }


    onChange()
    {
        this.listeners.forEach(listener =>
        {
            listener.callback.call(listener.scope, this._value);
        });
    }



}


export namespace Value
{


    export interface Options
    {
        decimals?: number;
        min?: number | null;
        max?: number | null;
        editable?: boolean;
        disable_on_spin?: boolean;
        enabled?: boolean;
    }


    export namespace ID
    {
        export const BET: ValueId = "bet";
        export const ROLLOVER: ValueId = "rollover";
        export const TOGGLEROLLOVER: ValueId = "rollovertoggle";
        export const MULTIPLIER: ValueId = "multiplier";
        export const AUTOPLAY: ValueId = "autoplay";
        export const CASHOUT: ValueId = "cashout";
        
        export const BALANCE: ValueId = "balance";

        export const MIN_BET: ValueId = "min_bet";
        export const MAX_BET: ValueId = "max_bet";
        export const MIN_CASHOUT: ValueId = "min_cashout";
        export const MAX_CASHOUT: ValueId = "max_cashout";
        export const MAX_WIN: ValueId = "max_win";
    }


    export namespace Options
    {


        export const Normal: Value.Options = {
            disable_on_spin: true
        };


        export const NoEdit: Value.Options = {
            editable: false
        };


    }


}

// @ts-ignore
window.Value = Value;